import { IModel, Collection } from 'app/model/base/annotation';
import { Metamodel } from 'app/model/base/model';
import { ParameterValue } from 'app/model/base/parameter-value';
import { Owned } from 'app/model/base/named';

@Metamodel.model({})
export class ReferenceObjectParameters extends Owned {
    public static readonly MODEL: IModel;

    @Metamodel.attribute({
        collection: Collection.Array
    })
    public parameters?: ParameterValue[] = [];
}
